import { createFileRoute } from '@tanstack/react-router';
import InvoicingExportsPage from '@features/admin/orders/InvoicingExportsPage';

export const Route = createFileRoute('/admin/invoicing-exports/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <InvoicingExportsPage />;
}
